// ---------------------------
// Component Index
// This page imports and exports the various app components for declaritive imports app-wise.
// If you create a new component, import it here, and it will be available via ES6 {Import}

import GlobalPropsStore from './CT5PropsStore';

class RootStore {
  constructor() {
    this.globalPropsStore = new GlobalPropsStore(this);
  }
}

export default RootStore;
